var AccelerationUnit_1;
import { __decorate } from "tslib";
import { SerializableObject } from '../../data/decorators';
import { DerivedUnit } from './DerivedUnit';
import { LengthUnit } from './LengthUnit';
import { TimeUnit } from './TimeUnit';
/**
 * @category Unit
 */
let AccelerationUnit = AccelerationUnit_1 = class AccelerationUnit extends DerivedUnit {};
AccelerationUnit.METER_PER_SECOND_SQUARE = new AccelerationUnit_1('meter per second squared', {
  baseName: 'acceleration',
  aliases: ['m/s^2', 'm/s2', 'meters per second squared']
}).addUnit(LengthUnit.METER, 1).addUnit(TimeUnit.SECOND, -2);
AccelerationUnit.GRAVITATIONAL_FORCE = new AccelerationUnit_1('gravitational force', {
  baseName: 'acceleration',
  aliases: ['g-force', 'G', 'GS'],
  definitions: [{
    magnitude: 9.78033,
    unit: 'm/s^2'
  }]
});
AccelerationUnit = AccelerationUnit_1 = __decorate([SerializableObject()], AccelerationUnit);
export { AccelerationUnit };